<app-filter-header title="Filtrar motius desestimar" i18n-title  (apply)="this.apply()" (reset)="this.reset()" (dismiss)="this.dismiss()"></app-filter-header>
<div class="modal-body">
  <div class="row col">
    <app-filter-text-edit id="motius-anulacio-filter-descripcio" class="col-sm-9" i18n-label label="Descripció" [(value)]="this.filter.descripcio" contains></app-filter-text-edit>    
  </div>
  <div class="row col">
    <app-form-tri-state label="Canvi Matrícula" i18n-label labelSi="Si" i18n-label labelNo = "No" i18n-label labelTodos="Tots" [(value)]="this.filter.canviMatricula"></app-form-tri-state>
  </div>
</div>
